const okInsuranceReducers = require('./reducers');
const okInsuranceActions = require('./actions');
const okInsuranceViews = require('./routes');
const okInsuranceComponents = require('./components');
const okInsuranceConstants = require('./insuranceConstants');

module.exports = {
    okInsuranceReducers,
    okInsuranceActions,
    okInsuranceViews,
    okInsuranceComponents,
    okInsuranceConstants
};
